import { ListBaseController } from "../components/fx";
import * as controlService from "../services/ControlService";

const pageConfig: any = {
    pageTitle: 'Controls',
    sections: [
        {
            type: "filter",
            layout: 4,
            controls: [
                { label: 'Control Code', model: 'controlCode', type: 'text' },
                { label: 'Display', model: 'display', type: 'text' },
                { label: 'Parent Control Code', model: 'parentControlCode', type: 'combo', default: true, defaultValue: "-1", valueField: "code", displayField: "text", lookupKey: "ParentControls" }
            ]
        },
        {
            type: "listview",
            listViewConfig: {
                canShowHeader: true,
                pagerConfig: {
                    pageSize: 25
                },
                sorterConfig: {
                    sortable: true,
                    sortInfo: {
                        name: "created_at",
                        direction: "desc"
                    }
                },
                mode: 'normal',
                fieldDefs: [
                    { field: 'controlCode', title: 'Control Code', type: 'label', size: 2, sort: true },
                    { field: 'display', title: 'Display', type: 'label', size: 2, sort: true },
                    { field: 'parentControlCode', title: 'Parent Control Code', type: 'lookup', lookupKey: 'ParentControls', size: 2, sort: true },
                    { field: 'routeRef', title: 'Route Ref', type: 'label', size: 2 },
                    { field: 'moduleCode', title: 'Module Code', type: 'label', size: 2, sort: true },
                    { field: 'actions', title: 'Actions', type: 'label', size: 2 }
                ],
                actions: [
                    { name: 'edit', displayText: 'Edit' },
                    { name: 'delete', displayText: 'Delete', placeholder: 'display' }
                ]
            }
        }
    ],
    actionBar: {
        controls: [
            { name: "add" }
        ]
    }
}

const listBaseController = ListBaseController({
    pageConfig: pageConfig,
    actions: {
        getItems: controlService.getControls,
        deleteItem: controlService.deleteControl,
        getLookups: controlService.getLookups
    }
}
);

export const useControlListStore = listBaseController.getStore();